// To remove with cleanup of empanada_nin_convert_issue_ops_to_entrypoint as we are moving this AttachFileDialog to an entrypoint
import React from 'react';
import { ModalBoundary } from '@atlassian/jira-modal/src/ui/modal-boundary/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type AttachFileDialog from './index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const AsyncAttachFileModal = lazy<typeof AttachFileDialog>(
	() => import(/* webpackChunkName: "async-issue-operations-attach-file-modal" */ './index'),
	{ entryFsSsrLiftImportToModule: true },
);

const LazyAttachFileModal = (): React.JSX.Element => (
	<ModalBoundary id="attach-file-dialog" packageName="native-issue-table">
		<AsyncAttachFileModal />
	</ModalBoundary>
);

export default LazyAttachFileModal;
